import { render, staticRenderFns } from "./brand-alias.vue?vue&type=template&id=6a43710e&"
import script from "./brand-alias.vue?vue&type=script&lang=js&"
export * from "./brand-alias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports